import styled from 'styled-components';

export default styled.div`
  text-align: center;
  margin-top: 3rem;
`;
